import React from "react"
import { IconWrapper, IconCircleStroke, IconPolygon } from "shared/Styles/Icons"

const ScrollTop = ({color}) => (
  <>
    <IconWrapper width={"68px"} height={"68px"}>
      <IconCircleStroke
        fill="transparent"
        strokeWidth="2"
        r="30"
        cx="34"
        cy="34"
        color={color}
      ></IconCircleStroke>
    </IconWrapper>
    <IconWrapper
      height={"10px"}
      color={color}
      style={{transform: "translateY(-40px) rotateZ(-90deg)"}}
      version="1.1"
      id="Tryb_izolacji"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 231 198"
    >
      <IconPolygon color={color} points="132,0 132,66 0,66 0,132 132,132 132,198 231,99 "></IconPolygon>
    </IconWrapper>
  </>
)

export { ScrollTop }
